/**
 * Breakpoint tokens
 * Defines responsive breakpoints for mobile-first design
 */

export const breakpoints = {
  // Breakpoint values (px)
  sm: '640px', // Small devices (landscape phones)
  md: '768px', // Medium devices (tablets)
  lg: '1024px', // Large devices (desktops)
  xl: '1280px', // Extra large devices (large desktops)
  '2xl': '1536px', // 2X Extra large devices

  // Media query helpers
  up: {
    sm: `@media (min-width: 640px)`,
    md: `@media (min-width: 768px)`,
    lg: `@media (min-width: 1024px)`,
    xl: `@media (min-width: 1280px)`,
    '2xl': `@media (min-width: 1536px)`,
  },

  down: {
    sm: `@media (max-width: 639px)`,
    md: `@media (max-width: 767px)`,
    lg: `@media (max-width: 1023px)`,
    xl: `@media (max-width: 1279px)`,
    '2xl': `@media (max-width: 1535px)`,
  },
} as const;

export type Breakpoints = typeof breakpoints;
